import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import { TitleSection } from '../../components/title-sections/title-sections';
import { Category, CategoryFilter, SecretaryCard } from './secretary.container';
import { SecretaryCardListContainer } from './secretary-card-list/secretary-card-list.container';
import { FilterTitle } from './style';
import { Pagination } from '../../components';
import {
  Breadcrumbs,
  PageHeader,
  SearchBar,
} from '@plataforma-xvia/design-system-es';
import { ROUTES } from '../../routes';
import { buildAppPath } from '../../utils/basePath';
import styles from './styles.module.css';
import { CheckboxCheckedIcon, CheckboxUncheckedIcon } from '../../icons/CheckboxIcon';

export interface SecretaryCardListProps {
  cards: SecretaryCard[];
  categories: Category[];
  totalPages: number;
  handleChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
  toggleDrawer: (newOpen: boolean) => () => void;
  selectedCategories: CategoryFilter[];
  handleCheckboxChange: (filter: CategoryFilter) => void;
  handleFilterByCategory: () => void;
  open: boolean;
  onClickSearch: () => void;
  onChangeText: (text: string) => void;
  value: string;
}

export const Secretary: FC<SecretaryCardListProps> = ({
  cards,
  categories,
  totalPages,
  handleChange,
  page,
  toggleDrawer,
  selectedCategories,
  handleCheckboxChange,
  handleFilterByCategory,
  open,
  onClickSearch,
  onChangeText,
  value,
}) => {
  const DrawerList = (
    <Box sx={{ p: 2 }} role="presentation">
      <Box sx={{ textAlign: 'end' }} role="presentation">
        <Button
          onClick={toggleDrawer(false)}
          style={{
            background: 'transparent',
            color: '#000',
          }}
          endIcon={<CloseIcon sx={{ width: '20px' }} />}
        ></Button>
      </Box>
      <TitleSection
        titleSettings={{
          title: 'Filtro',
          colorTitle: '#202020',
          fontSizeTitle: '16px',
          subtitle: 'Selecione os filtros que deseja ver abaixo',
          colorSubtitle: '#7B7B7B',
          fontSizeSubtitle: '14px',
        }}
        iconSettings={{
          displayIcon: true,
          sectionIcon: <FilterAltIcon style={{ margin: '0 10px' }} />,
          iconColor: '#9E9E9E',
          iconSize: '30px',
          iconMargin: '0px 10px',
        }}
      />
      <FilterTitle>Categorias</FilterTitle>
      <FormGroup>
        {categories.map(({ id, name }) => (
          <FormControlLabel
            key={id}
            control={
              <Checkbox
                checked={selectedCategories.some((item) => item.id === id)}
                onChange={() => handleCheckboxChange({ id, name })}
                icon={<CheckboxUncheckedIcon />}
                checkedIcon={<CheckboxCheckedIcon />}
              />
            }
            label={name}
          />
        ))}
      </FormGroup>
      <Box sx={{ textAlign: 'end', p: 3 }} role="presentation">
        <Button variant="contained" onClick={() => handleFilterByCategory()}>
          Filtrar
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      <Drawer open={open} onClose={toggleDrawer(false)} anchor="right">
        {DrawerList}
      </Drawer>

      <PageHeader
        title="Órgãos e Secretarias"
        className={styles.pageHeader}
        breadcrumb={
          <Breadcrumbs
            tone="inverted"
            showBackButton
            items={[
              { name: 'Início', path: buildAppPath(ROUTES.HOME_PAGE) },
              { name: 'Órgãos e Secretarias' },
            ]}
          />
        }
      />

      <div className={styles.secretaryPage}>
        <div className={styles.searchWrapper}>
          <SearchBar
            className={`${styles.searchOnly} ${styles.searchBar}`}
            placeholder="Como posso te ajudar?"
            onClickSearch={onClickSearch}
            onChangeText={onChangeText}
            value={value}
          />
        </div>

        <div className={styles.secretaryContainer}>
          <SecretaryCardListContainer cards={cards} />
        </div>

        <div className={styles.paginationWrapper}>
          <Pagination count={totalPages} onChange={handleChange} page={page} />
        </div>
      </div>
    </>
  );
};
